import { ArrowRightLeft } from "lucide-react";

export const OUTPUT_FILTERS = [
	{
		key: "business_id",
		label: "Razón Social",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar razón social",
		options: [],
	},
	{
		key: "aptitude_id",
		label: "Aptitud",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar aptitud",
		options: [],
		multiple: true,
	},
	{
		key: "business_center_id",
		label: "Centro de Costo",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar centro de costo",
		options: [],
		multiple: true,
	},
	{
		key: "operator_id",
		label: "Operador",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar operador",
		options: [],
	},
	{
		key: "type_oa_id",
		label: "Tipo OA",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo OA",
		options: [],
	},
	{
		key: "oa_code",
		label: "N° OA",
		type: "text",
		value: "",
		visible: true,
		placeholder: "Ingresar N° OA",
	},
	{
		key: "type_movement_id",
		label: "Tipo de Movimiento",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo de movimiento",
		options: [
			{ value: "1", label: "Aplicación" },
			{ value: "2", label: "Traspaso" },
			{ value: "3", label: "Nota de Crédito" },
			{ value: "4", label: "Robo" },
		],
	},
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{ key: "date_from", label: "Fecha Salida Desde", type: "date", value: "", visible: true, placeholder: "Fecha salida desde" },
	{ key: "date_to", label: "Fecha Salida Hasta", type: "date", value: "", visible: true, placeholder: "Fecha salida hasta" },
];

export const OUTPUT_METADATA = {
	title: "Historial de Salidas",
	subtitle: "Visualiza el historial de todas las salidas de productos",
	breadcrumb: "Salidas",
	icon: ArrowRightLeft,
	path: "/historiales/salida",
	apiType: "output",
};

export const OUTPUT_BASE_TABLE = {
	page: 1,
	per_page: 100,
	order_by: "created_date",
	order_dir: "desc",
};
